import { useSearchByKeyword } from "@/hooks/useSearchByKeyword";
import { chatsApi } from "@/lib/humhub-api/chats";
import type { ChatRoomType } from "@/lib/humhub-api/types";

export const useSearchChatEntries = (
  initialKeyword?: string,
  initialType?: ChatRoomType,
) => {
  const searchState = useSearchByKeyword({
    keyBase: "searchChatEntries",
    initialKeyword,
    initialType,
    fetcher: chatsApi.searchEntries,
    staleTimeMs: 2 * 60 * 1000,
  });

  return {
    isLoading: searchState.isLoading,
    error: searchState.error,
    searchChatEntries: searchState.search,
    response: searchState.response,
    refetchSearch: searchState.refetchSearch,
    prefetchSearch: searchState.prefetchSearch,
    clearSearch: searchState.clearSearch,
    currentKeyword: searchState.currentKeyword,
  };
};
